import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.852.734h10.296v2.06h5.147v16.472H.705V4.852h2.058v12.355h16.473V4.852h-5.148V2.793H7.911v2.06H.704v-2.06h5.148zm7.207 12.355H8.94v2.059h4.118zm-4.118-2.06v2.06H6.88v-2.06zm0-2.059V6.911H6.88v2.06zm6.177 2.06v2.059h-2.06v-2.06zm0-2.06V6.911h-2.06v2.06z"
    }, null, -1)
  ])))
}
export default { render: render }